<template>
  <div
    class="modal fade modal-data-pack"
    ref="modalDataPack"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="mobileNumberModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header pb-1">
          <h6 class="text-navy-blue">Application Package</h6>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12 my-4">
              <h6 class="text-center">
                Please select the Application Package you would like to avail
              </h6>
            </div>
            <div class="col-12">
              <!-- @click.prevent="selectSku(sku)" -->
              <div
                class="price-item-border shadow-sm"
                :class="{ active: isActive.skuId == sku.skuId }"
                v-for="(sku, i) in filteredSkus"
                :key="i"
                @click.prevent="selectSku(sku)"
              >
                <div class="row">
                  <div class="col-9 p-2 pl-2">
                    <div class="rate-container">
                      <div>
                        <div class="rate-title d-flex gap-2">
                          <div>{{ sku.skuName }}</div>
                          <div class="rate-speed">
                            {{ sku.addDesc1 }}
                          </div>
                        </div>
                        <div class="rate-description fw-bold mt-2 mb-4">
                          {{ sku.description }}
                        </div>
                        <div class="rate-description">
                          {{ sku.addDesc2 }}
                        </div>
                      </div>

                      <!-- <div
                        v-if="sku.skuName.toLowerCase() === 'extraboost'"
                        class="mt-2"
                      >
                        <div>
                          <p class="m-0 p-0">
                            <a href="#"
                              >Enjoy your favorite channels with SkyTV</a
                            >
                          </p>
                          <p class="m-0 p-0">
                            Xperience Hub is needed to access SkyTV Channels
                          </p>
                        </div>
                        <div class="d-flex align-items-center gap-2 mt-3">
                          <div class="form-check" @click.stop>
                            <input
                              class="form-check-input checkbox-theme"
                              type="checkbox"
                              v-model="withDevice"
                              id="defaultCheck1"
                              @change="handleDeviceChange(sku)"
                            />
                            <label class="form-check-label" for="defaultCheck1">
                              Avail of the Xperience Hub for P
                              {{ sku.deviceCost }}
                            </label>
                          </div>
                        </div>
                      </div> -->
                    </div>
                  </div>
                  <div
                    class="col-3 d-flex justify-content-center align-items-center flex-column p-2"
                  >
                    <div class="price-item" :class="background">
                      <div>
                        <div class="currency">PHP</div>
                        <!-- <div
                          v-if="sku.withDevice === '1'"
                          class="price price--slashed"
                        >
                          <span v-if="withDevice">{{
                            formatPrice(sku.totalCost)
                          }}</span>
                          <span v-else>{{ formatPrice(sku.price) }}</span>
                          <span class="slash-line" aria-hidden="true"></span>
                        </div>
                        <div v-else class="price price--slashed">
                          {{ formatPrice(sku.price) }}
                          <span class="slash-line" aria-hidden="true"></span>
                        </div> -->

                        <div class="price">
                          {{ formatPrice(sku.origPrice || 0) }}
                          <!-- <span class="slash-line" aria-hidden="true"></span> -->
                        </div>
                      </div>
                    </div>

                    <!-- <div
                      class="fw-bold mt-1"
                      style="color: #ff7200; font-size: 1rem"
                      v-if="sku.withDevice === '1'"
                    >
                      <span v-if="withDevice">
                        ₱ {{ formatPrice(sku.totalCost) }} na lang
                      </span>
                      <span v-else>
                        ₱ {{ formatPrice(sku.price) }} na lang
                      </span>
                    </div>

                    <div
                      class="fw-bold mt-1"
                      style="color: #ff7200; font-size: 1rem"
                      v-else
                    >
                      ₱ {{ formatPrice(sku.totalCost) }} na lang
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer border-0 d-flex justify-content-center">
          <button
            type="button"
            class="btn btn-s2s-blue px-5 rounded-pill"
            :disabled="Object.keys(GET_DATAPACK).length === 0"
            @click.prevent="confirmDatapack()"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
export default {
  data() {
    return {
      background: "bg-f30",
      modal: null,
      resolve: null,
      reject: null,

      modals: {
        mobileNumber: null,
      },

      skus: [],
      filteredSkus: [], // park sku here
      selectedSku: {},

      mobileNumber: "",
      submitted: false,
      withDevice: false,

      isCod: false,
    };
  },
  methods: {
    handleDeviceChange(item) {
      item.isWithDevice = this.withDevice;

      if (this.withDevice && item.skuName.toLowerCase() === "extraboost") {
        const selectedSku = [...this.skus].find(
          (sku) =>
            sku.skuName.toLowerCase() === "extraboost" && sku.withDevice === "1"
        );
        this.$store.dispatch("ADD_DATAPACK", selectedSku);

        this.filteredSkus.splice(1, 1, selectedSku);
      } else {
        const selectedSku = [...this.skus].find(
          (sku) =>
            sku.skuName.toLowerCase() === "extraboost" && sku.withDevice === "0"
        );
        this.filteredSkus.splice(1, 1, selectedSku);
        this.$store.dispatch("ADD_DATAPACK", selectedSku);
      }

      // console.log("Selected SKU after device change:", this.filteredSkus);
      // if (item.skuName.toLowerCase() === "extraboost") {
      //   item.isWithDevice = this.withDevice;
      //   this.selectSku(item);

      //   const selectedSku = [...this.skus].find(
      //     (sku) =>
      //       sku.skuName.toLowerCase() === "extraboost" &&
      //       sku.withDevice === (this.withDevice ? "1" : "0")
      //   );
      //   this.$store.dispatch("ADD_DATAPACK", selectedSku);
      // } else {

      // }

      // this.$store.dispatch("ADD_DATAPACK", item);
    },

    formatPrice(num) {
      return parseInt(num, 10).toLocaleString("en-US");
    },

    getSpeed(text) {
      const mbpsMatch = text.match(/(\d+(?:\.\d+)?)\s*mbps/i);
      const mbpsValue = mbpsMatch ? mbpsMatch[0] : null;

      return mbpsValue;
    },

    selectSku(item) {
      if (item.withDevice === "0") {
        item.isWithDevice = false;
      } else {
        item.isWithDevice = this.withDevice;
      }

      this.$store.dispatch("ADD_DATAPACK", item);
    },

    open(force, isCod = false) {
      const sku = this.$store.getters.GET_DATAPACK;

      if (Object.keys(sku).length === 0) {
        // this.getLocation();
        // console.log("Asdasda");
        this.modal.show();
      }

      if (force) {
        this.modal.show();
      }

      this.isCod = isCod;

      // this.title = title;
      // this.message = message;
      // this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    confirmDatapack() {
      // if (this.isCod) {
      this.resolve({ status: true, isCod: this.isCod });
      this.modal.hide();
      return;
      // }
    },

    agree() {
      this.resolve(true);
      // this.dialog = false;
      this.modal.hide();
    },
    cancel() {
      this.resolve(false);
      // this.dialog = false;
      this.modal.hide();
    },

    async getSKUs() {
      await this.$broker
        .post("/broker/retailer/iptv-installation-sku-list", {
          cityCode: this.$store.getters.GET_CITYCODE,
        })
        .then((response) => {
          const res = response.data;

          // 710000047
          // 710000046
          // const removeSku = ["710000047", "710000046"];
          // const displaySKU = ["710000057", "710000056"];
          this.skus = res.data;

          // this.listSkus = res.data;

          const filteredSku = [...this.skus].filter(
            (sku) =>
              !(
                sku.skuName.toLowerCase() === "extraboost" &&
                sku.withDevice === "1"
              )
          );
          this.filteredSkus = filteredSku;

          // this.skus = res.data.list.filter((item) =>
          //   displaySKU.includes(item.skuId)
          // );
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  mounted() {
    this.modal = new Modal(this.$refs.modalDataPack, {
      keyboard: false,
    });
  },

  computed: {
    isActive() {
      const sku = this.$store.getters.GET_DATAPACK;
      var def = { skuId: 0 };
      if (Object.keys(sku).length != 0) {
        return sku;
      }

      return def;
    },

    GET_DATAPACK() {
      return this.$store.getters.GET_DATAPACK;
    },
  },

  created() {
    this.getSKUs();
  },
};
</script>

<style scoped>
.rate-speed {
  border-radius: 4px;
  background: #ffb63b;
  font-size: 10px;
  color: #000;
  padding: 2px 6px;
  display: flex;
  align-items: center;
}

/* Slash style for price inside the circle */
.price {
  position: relative;
  display: inline-block;
}
.slash-line {
  position: absolute;
  left: -10%;
  right: -10%;
  top: 50%;
  height: 3px;
  background: #fff; /* visible on purple background */
  transform: rotate(-18deg);
  border-radius: 4px;
  pointer-events: none;
}
</style>
